// Ð§Ð¸ÑÑÑÐµ ÑÑÐ½ÐºÑÐ¸Ð¸ ÑÑÑÐ°Ð½Ð¸ÑÑ Â«Ð§ÑÑÐ½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº VINÂ» â Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾ Ð¾Ñ ÑÐ°Ð·Ð¼ÐµÑÐºÐ¸, ÑÑÐ¾Ð±Ñ Ð¿ÑÐ¾Ð²ÐµÑÑÑÑ ÑÐµÑÑÐ¾Ð¼.

export const ALLOWED_EXTENSIONS = ['.xlsx', '.xls', '.csv'];
export const MAX_FILE_SIZE_MB = 10;

// Ð¢ÐµÐºÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¸ Ð´Ð»Ñ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð¾Ð³Ð¾ ÑÐ°Ð¹Ð»Ð°; Ð¿ÑÑÑÐ°Ñ ÑÑÑÐ¾ÐºÐ° â ÑÐ°Ð¹Ð» Ð³Ð¾Ð´Ð¸ÑÑÑ.
export const fileProblem = (file) => {
  const name = file?.name || '';
  const dot = name.lastIndexOf('.');
  const ext = dot === -1 ? '' : name.slice(dot).toLowerCase();
  if (!ALLOWED_EXTENSIONS.includes(ext)) {
    return `Ð¤Ð°Ð¹Ð» Â«${name}Â»: Ð½ÐµÐ´Ð¾Ð¿ÑÑÑÐ¸Ð¼ÑÐ¹ ÑÐ¾ÑÐ¼Ð°Ñ. ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ .xlsx, .xls Ð¸Ð»Ð¸ .csv`;
  }
  if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
    return `Ð¤Ð°Ð¹Ð» Â«${name}Â» Ð±Ð¾Ð»ÑÑÐµ ${MAX_FILE_SIZE_MB} ÐÐ`;
  }
  return '';
};

// ÐÑÐ¾Ð³ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÐ°Ð¹Ð»Ð° Ð´Ð»Ñ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°: ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð´Ð¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¾, ÑÐºÐ¾Ð»ÑÐºÐ¾ ÑÐ¶Ðµ Ð±ÑÐ»Ð¾, ÐºÐ°ÐºÐ¸Ðµ ÑÑÑÐ¾ÐºÐ¸ Ð¿ÑÐ¾Ð¿ÑÑÐµÐ½Ñ.
export const importSummary = (data) => {
  const added = data?.added ?? 0;
  const already = data?.alreadyInList ?? 0;
  const bad = data?.badRows || [];
  const parts = [`ÐÐ¾Ð±Ð°Ð²Ð»ÐµÐ½Ð¾: ${added}`];
  if (already > 0) parts.push(`ÑÐ¶Ðµ Ð±ÑÐ»Ð¸ Ð² ÑÐ¿Ð¸ÑÐºÐµ: ${already}`);
  if (bad.length > 0) {
    const rows = bad
      .slice(0, 10)
      .map((item) => item.row)
      .join(', ');
    parts.push(`Ð¿ÑÐ¾Ð¿ÑÑÐµÐ½Ð¾ ÑÑÑÐ¾Ðº Ð±ÐµÐ· ÐºÐ¾ÑÑÐµÐºÑÐ½Ð¾Ð³Ð¾ VIN: ${bad.length} (ÑÑÑÐ¾ÐºÐ¸ ${rows}${bad.length > 10 ? 'â¦' : ''})`);
  }
  return parts.join(', ');
};

export const VIN_LENGTH = 17;

// ÐÐ²Ð¾Ð´ VIN: Ð·Ð°Ð³Ð»Ð°Ð²Ð½ÑÐµ Ð»Ð°ÑÐ¸Ð½Ð¸ÑÐ° Ð¸ ÑÐ¸ÑÑÑ, Ð½Ðµ Ð´Ð»Ð¸Ð½Ð½ÐµÐµ 17 (ÐºÐ°Ðº Ð²ÐµÐ·Ð´Ðµ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð°Ð²ÑÐ¾)
export const normalizeVinInput = (raw) =>
  String(raw || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, VIN_LENGTH);

// ÐÑÐ¸Ð¼ÐµÑ ÑÐ°Ð¹Ð»Ð° Ð´Ð»Ñ Ð¸Ð¼Ð¿Ð¾ÑÑÐ°: UTF-8 Ñ BOM Ð¸ Â«;Â» â ÑÐ°Ðº ÐµÐ³Ð¾ Ð¾ÑÐºÑÑÐ²Ð°ÐµÑ ÑÑÑÑÐºÐ¸Ð¹ Excel, Ð±ÑÐº ÑÐ¸ÑÐ°ÐµÑ Ð¸ ÑÐ°ÐºÐ¾Ð¹ CSV
export const SAMPLE_CSV = '\uFEFFVIN;ÐÑÐ¸ÑÐ¸Ð½Ð°\r\nWVWZZZ1JZXW000001;ÐÐ¾Ð´Ð´ÐµÐ»ÑÐ½ÑÐ¹ ÐÐ¢Ð¡\r\nLSVNN2184C2000002;\r\n';
export const SAMPLE_CSV_HREF = `data:text/csv;charset=utf-8,${encodeURIComponent(SAMPLE_CSV)}`;
